var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('div',{staticClass:"BackToTop",on:{"click":_vm.onButtonClick}},[_c('AngleRightIcon')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }